import { supabase } from '../config/supabase';

// Initialize storage structure
export const initStorage = async (): Promise<void> => {
  try {
    // Check if logos folder exists
    const { data, error } = await supabase.storage
      .from('assets')
      .list('logos');
    
    if (error && error.message !== 'The resource was not found') {
      console.error('Error checking storage structure:', error);
    }
    
    // If folder doesn't exist, create an empty placeholder file
    if (!data || data.length === 0) {
      const emptyFile = new Blob([''], { type: 'text/plain' });
      await supabase.storage
        .from('assets')
        .upload('logos/.placeholder', emptyFile, {
          cacheControl: '3600',
          upsert: true
        });
    }
  } catch (error) {
    console.error('Error initializing storage:', error);
  }
};

export const uploadBusinessLogo = async (file: File, businessId: string): Promise<string> => {
  try {
    // Ensure storage is initialized
    await initStorage();
    
    // Check if file is valid
    if (!file || file.size === 0) {
      throw new Error('Invalid file');
    }

    // Create a unique filename to avoid collisions
    const fileExt = file.name.split('.').pop();
    const timestamp = new Date().getTime();
    const fileName = `${businessId}_logo_${timestamp}.${fileExt}`;
    
    // Upload to Supabase
    const { data, error } = await supabase.storage
      .from('assets')
      .upload(`logos/${fileName}`, file, {
        cacheControl: '3600',
        upsert: true
      });

    if (error) {
      console.error('Storage error:', error);
      throw error;
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('assets')
      .getPublicUrl(`logos/${fileName}`);

    return publicUrl;
  } catch (error) {
    console.error('Error uploading logo:', error);
    throw error;
  }
}; 